// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TMY_","label":"styles_label__3iXx9"};